import { useEffect, useState, useMemo } from "react";
import PremiumPageHeader from '../../components/PremiumPageHeader';
import { ListPageFloatingControls } from '../../components/ListPageLayout';
import ReactTableWrapper from "../../components/ReactTableWrapper";
import { exportAsCSV } from "../../utils/CSVExporter";
import { exportAsPDF } from "../../utils/PDFExporter";
import { useNavigate } from "react-router-dom";
import "../../App.css";
import Sidebar from '../../Sidebar';
import Swal from "sweetalert2";
import { useCookies } from 'react-cookie';
import { getAllIPAddress, deleteIPAddress } from "../../services/IPAddressServices";
import { displayError } from "../../helpers";

function IPAddressTable() {
    const InitialData = {
        total_pages: 0,
        records: [],
      };
    const [data, setData] = useState(InitialData);
    const navigate = useNavigate(); 
    const [refreshKey, setRefreshKey] = useState(0);
    const [cookies] = useCookies(['myToken']);
    const [isLoading, setIsLoading] = useState(true); 

    const columns = useMemo(
        () => [
            {
                fieldName: 'ip_addr', 
                headerName: 'IP Address'
            },
           
            {
                fieldName: "user_remarks",
                headerName: 'Remarks'
            },
            {
              fieldName: "status",
              headerName: 'Status'
          },
        
            {
                fieldName: "id",
                headerName: "ROW_ACTIONS"
            }
       
         
        ],
        [],);

    const onEditIPAddress = (ipaddressId, event) => {
       
       navigate(`/IpAddressEdit/${ipaddressId}/`);
    };

    const onDeleteIPAddress = (ipaddressId, event) => {

        event.preventDefault();
        Swal.fire({title: 'Are you sure to Delete?',  
        showCancelButton: true,  
        confirmButtonText: `Yes`,  
        cancelButtonText: `No`,
        }).then((result) => {  
          if (result.isConfirmed) { 
            setIsLoading(true);
            deleteIPAddress(cookies, ipaddressId).then(response => {
                console.log(`IP with id ${ipaddressId} deleted`);
                Swal.fire('Deleted Successfully!', '', 'success');
                setRefreshKey(oldKey => oldKey +1)
            })
            .catch(error => {
                console.log(error.response.data);
                displayError(error.response.data,'Delete Failed');
            });  
           
          } else if (result.isDismissed) {    
            Swal.fire('Not Deleted', '', 'info')  
        }
        });
        //

    };
    const handleCSVExport = (event) => {
        console.log('CSV Export');
        exportAsCSV(
            columns
            .filter(col => col.headerName !== 'ROW_ACTIONS')
            .map(c => c.headerName),
            data.records.map(ip => {

                const csvRow = {
                    ip_addr_category: ip.ip_addr_category,
                    user_remarks: ip.user_remarks,
                    status:ip.status
                    
                }
                return csvRow;
                }));
    };

    const handlePDFExport = (event) => {
        console.log('PDF Export');
        exportAsPDF(
            'List of IPAddress Form',
            columns
            .filter(col => col.headerName !== 'ROW_ACTIONS')
            .map(col=>({header: col.headerName, dataKey: col.fieldName })),
            data.records.map(ip => ({
                ip_addr_category: ip.ip_addr_category,
                user_remarks: ip.user_remarks,
                status:ip.status
            })),
            'IPAddress_Forms.pdf'
        );
    };

    useEffect(() => {

        getAllIPAddress(cookies)
        .then( ipaddressList => {
            const tableData = ipaddressList.ip_list
            .map(ip => ({
                id :ip.id,
                ip_addr: ip.ip_addr?ip.ip_addr:ip.ip_addr_category.toUpperCase(),
                user_remarks: ip.user_remarks,
                status:ip.status? "Active":"Inactive",
                 
            }));

            setData({
                total: data.total,
                records: tableData
            });
            setIsLoading(false);
        });
        }, [refreshKey]);
    
    return (

        <div id="outer-container"  className="App" > 
            <Sidebar pageWrapId={'page-wrap'} outerContainerId={'outer-container'} />
            <div id="page-wrap">
                <ListPageFloatingControls
                    formLink="/IpAddress"
                    addNewLabel="New IP Address"
                    homeLink="/Home"
                    onExportCSV={handleCSVExport}
                    onExportPDF={handlePDFExport}
                />
                <div className="container">
                    <PremiumPageHeader
                        module="ADMIN"
                        title="List of IP Addresses"
                        subtitle="Browse IP-based user access control rules."
                        modeLabel="VIEW MODE"
                    />
                </div>
                <div className="container item-list-table-container">
                <div className="table-responsive">
                <ReactTableWrapper
                            title='List of IPAddress Form'
                            columns={columns}
                            data={data.records}
                            onRowEdit={onEditIPAddress}
                            onRowDelete={onDeleteIPAddress}
                            onCSVExport={handleCSVExport}
                            onPDFExport={handlePDFExport}
                            isLoading={isLoading}
                        
                        />
                </div>
                </div>
            </div>
        </div>

        
    );

}



export default IPAddressTable;